<div class="calendar-weekly-view">
  <div class="calendar-grid-wrapper flexBox">
    <div [ngStyle]="{'grid-template-columns': timeGridColumns}" style="display: grid; gap: 0; overflow-y: auto;" #scrollContainer>
      <div class="calendar-time-grid-wrapper">
        <div class="calendar-time-col" [style.height.px]="totalAllDayRows * eventHeight + dayHeaderHeight + timeColHeight">
          <div class="calendar-all-day-time-col" [style.height.px]="totalAllDayRows * eventHeight + dayHeaderHeight"></div>
          @for (hour of hours; track hour) {
            <div class="calendar-time-slot" [ngStyle]="{'height': timeSlotHeight}">
              {{ formatHour(hour) }}
            </div>
          }
        </div>
      </div>
      <div style="display: grid; gap: 10px;" [ngStyle]="{'grid-template-columns': calendarGridColumns}">
        @for (calendar of data; track trackByCalendar($index, calendar)) {
          <div class="calendar-grid">
            <!-- All-day section: header + stacked all-day rows -->
            <div
              class="calendar-all-day-section"
              [style.height.px]="totalAllDayRows * eventHeight + dayHeaderHeight"
              [class.planning-header]="isPlanningEvent(calendar.id)"
              >
              <div class="calendar-all-day-content-col">
                <div class="title-row">
                  <div class="title-field" [style.height.px]="dayHeaderTitleHeight">{{ calendar.title }}</div>
                </div>
                <div class="calendar-all-day-content-row">
                  @for (day of days; track trackByDay($index, day); let last = $last) {
                    <div
                      class="calendar-all-day-col"
                      [class.city-holiday]="isCityHoliday(day, calendar)">
                      <div class="calendar-day-header" [style.height.px]="dayHeaderTimeHeight" [ngClass]="{ 'today-header': isToday(day),'last-child-calendar-day-header': last }">
                        {{ getDayLabel(day) }}
                      </div>
                      @for (row of totalAllDayRowsArray; track trackByRow($index, row)) {
                        <div class="calendar-all-day-row"></div>
                      }
                    </div>
                  }
                  <!-- All-day event blocks, absolutely positioned -->
                  @for (rowBlocks of calendar.allDayRows; track trackByRow(rowIdx, rowBlocks); let rowIdx = $index) {
                    @for (block of rowBlocks; track trackByBlock($index, block)) {
                      <div
                        [class.planning-event]="isPlanningEvent(calendar.id)"
                        class="calendar-all-day-block"
                        [class.city-holiday-block]="block.title?.toLowerCase()?.includes('holiday')"
                        [ngStyle]="block.title?.toLowerCase()?.includes('holiday') ? {'background-color':'#f6c84c','color':'white'} : (block.event.color && {'background-color': block.event.color, 'color': block.event.textColor || 'white'})"
                        [style.left.%]="(math.max(0, dayDiff(weekStart, block.start)) / 5) * 100 + 0.2"
                        [style.width.%]="((math.min(6, dayDiff(weekStart, block.end)) - math.max(0, dayDiff(weekStart, block.start)) + 1) / 5) * 100 - 0.4"
                        [style.top.px]="dayHeaderHeight + rowIdx * eventHeight + (rowIdx===0?2:0)"
                        [style.height.px]="eventHeight - 4"
                        (click)="onEventClick(block.event)"
                        (mouseover)="onEventMouseOver(block.event, $event)"
                        (mouseleave)="onEventMouseLeave()"
                        >
                        {{ block.title }}
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
            <div class="calendar-time-grid-wrapper">
              @for (day of days; track trackByDay(dayIdx, day); let dayIdx = $index; let first = $first) {
                <div
                  class="calendar-day-col"
                [ngClass]="{ 'today-col': isToday(day),
                              'first-child-calendar-day-col': first,
                              'city-holiday': isCityHoliday(day, calendar) }">
                  @for (hour of halfHours; track trackByHalfHour($index, hour)) {
                    <div class="calendar-day-half-hour-slot">
                    </div>
                  }
                  @for (layout of calendar.timedEventsByDay[dayIdx]; track trackByTimedEvent($index, layout)) {
                    <div
                      [class.planning-event]="isPlanningEvent(calendar.id)"
                      class="calendar-event"
                      [ngStyle]="layout.event.color && {'background-color': layout.event.color, 'color': layout.event.textColor || 'white'}"
                      [style.top.%]="((layout.event.localStart.getHours() + layout.event.localStart.getMinutes() / 60) / 24) * 100 + 0.1"
                      [style.height.%]="(((layout.event.localEnd.getHours() + layout.event.localEnd.getMinutes() / 60) - (layout.event.localStart.getHours() + layout.event.localStart.getMinutes() / 60)) / 24) * 100 -0.2"
                      [style.left.%]="(layout.col / layout.totalCols) * 100 + 1"
                      [style.width.%]="(1 / layout.totalCols) * 100 - 2"
                      (click)="onEventClick(layout.event)"
                      (mouseover)="onEventMouseOver(layout.event, $event)"
                      (mouseleave)="onEventMouseLeave()"
                      >
                      {{ layout.event.subject }}
                    </div>
                  }
                  <!-- Current time marker -->
                  @if (isThisWeek(day)) {
                    <div
                      class="calendar-now-marker"
                      [style.top.%]="currentTimeMarkerPosition"
                    ></div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>